// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3IXst","modalLayout":"Modal_modalLayout__3nBHE","modalContent":"Modal_modalContent__13mnI","closeBtnIcon":"Modal_closeBtnIcon__2xqu7"};